'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _animalHistory = require('./animal-history.html');

var _animalHistory2 = _interopRequireDefault(_animalHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _animalHistory2.default,
  bindings: {
    adverseEvent: '<',
    symptoms: '<',
    locked: '<'
  },
  controller: function () {
    function AnimalHistoryComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, AnimalHistoryComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(AnimalHistoryComponent, [{
      key: 'showConclusionQuestion',
      get: function get() {
        return this.adverseEvent.Question9a === true;
      }
    }]);

    return AnimalHistoryComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/animal-history/animal-history.component.js